<script>
import TableGenericList from "@/components/instrument/TableGenericList"
import { mapState } from "vuex"
import instrument from "../../store/instrument"

export default {
  name: "AssignedDqrTable",
  components: {
    TableGenericList,
  },
  props: {
    site: {
      type: String,
      default: "",
    },
    facility: {
      type: String,
      default: null,
    },
    instrument: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      debounceTimer: null,
      dqrInfo: [],
      dqrs: [],
      fields: [
        { key: "id", label: "DQR ID", sortable: true },
        { key: "statusDesc", label: "STATUS", sortable: true },
        { key: "siteCode", label: "SITE", sortable: true },
        { key: "facilityCode", label: "FACILITY", sortable: true },
        { key: "instrumentClassCode", label: "SYSTEM", sortable: true },
      ],
    }
  },
  computed: {
    ...mapState("instrument", ["personInstruments"]),
    itemsLoaded() {
      return this.dqrInfo.length > 0
    },
  },
  watch: {
    personInstruments: {
      handler() {
        this.updateDqrInfo()
      },
      immediate: true,
    },
    site: {

      handler() {
        this.updateDqrInfo() // Refresh data when site changes
      },
      immediate: true,
    },
    facility: {
      handler() {
        this.updateDqrInfo() // Refresh data when facility changes
      },
      immediate: true,
    },
    instrument: {
      handler() {
        this.updateDqrInfo() // Refresh data when instrument changes
      },
      immediate: true,
    },
  },
  mounted() {
    // console.log(
    //   "AssignedDqrTable mounted with site:", this.site, "facility:", this.facility, "instrument:", this.instrument,
    // )
  },
  created() {
    this.getAssignedDqrInfo()
  },
  methods: {
    getAssignedDqrInfo() {
      let filters = this.personInstruments.map((instr) => ({
        siteCode: instr.siteCode,
        facilityCode: instr.facilityCode,
        instrumentClassCode: instr.instrumentClassCode,
      }))
      // Apply site filter if a site is selected
      if (this.site) {
        filters = filters.filter(filter => filter.siteCode === this.site)
        console.log("After site filter:", filters)
      }

      // Apply facility filter if a facility is selected
      if (this.facility) {
        filters = filters.filter(filter => filter.facilityCode === this.facility)
        console.log("After facility filter:", filters)
      }

      // Apply instrument filter if an instrument is selected
      if (this.instrument) {
        filters = filters.filter(filter => filter.instrumentClassCode === this.instrument)
        console.log("After instrument filter:", filters)
      }

      this.$store
        .dispatch("instrument/retrieveAssignedDqrInfo", { filters })
        .then((data) => {
          this.dqrInfo = data
        })
        .catch((error) => {
          console.error("Error fetching Assigned DQR Info:", error)
        })
    },

    updateDqrInfo() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        let filters = this.personInstruments.map((instr) => ({
          siteCode: instr.siteCode,
          facilityCode: instr.facilityCode,
          instrumentClassCode: instr.instrumentClassCode,
        }))
        if (this.site) {
          filters = filters.filter(filter => filter.siteCode === this.site)
        }
        if (this.facility) {
          filters = filters.filter(filter => filter.facilityCode === this.facility)
        }
        if (this.instrument) {
          filters = filters.filter(filter => filter.instrumentClassCode === this.instrument)
        }

        this.$store
          .dispatch("instrument/retrieveAssignedDqrInfo", { filters })
          .then((data) => {
            this.dqrInfo = data
          })
          .catch((error) => {
            console.error("Error updating Assigned DQR Info:", error)
          })
      }, 100)
    },
  },
}
</script>

<template>
  <div id="tableView">
    <b-container class="gx-0">
      <b-row class="gx-0">
        <b-col class="gx-0">
          <div id="assignedDqrs" class="tableContainer">
            <h6 class="font-weight-bold pt-2 px-2 pb-0 mb-0 sectionHeader">Assigned DQRs</h6>
            <TableGenericList :fields="fields" :records="dqrInfo" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
.tableContainer {
  background: #95c8fb;
}
</style>
